// extracted by mini-css-extract-plugin
module.exports = {"card":"inspector-module--card--1c6Dm","imgBx":"inspector-module--imgBx--3DNd-","details":"inspector-module--details--N8zds"};